const SignUp = () => {
  return <i className="fa-solid fa-user-pen" aria-hidden="true" />;
};

export default SignUp;
